import { useState } from 'react';

const programs = [
  {
    id: 1,
    number: '01',
    title: 'Kano Community Epilepsy Champions',
    tag: 'Community',
    tagIcon: 'ri-group-line',
    icon: 'ri-user-star-line',
    color: '#7B2D8B',
    image: 'https://readdy.ai/api/search-image?query=Hausa%20community%20leader%20conducting%20epilepsy%20awareness%20session%20in%20Northern%20Nigeria%20mosque%20courtyard%2C%20diverse%20group%20of%20men%20and%20women%20listening%20attentively%2C%20traditional%20attire%2C%20warm%20afternoon%20light%2C%20authentic%20and%20respectful%20atmosphere%2C%20educational%20setting&width=800&height=500&seq=prog101&orientation=landscape',
    summary: 'A network of trained community champions — teachers, women leaders, faith leaders, patent medicine vendors, and community health workers — correcting harmful myths and teaching seizure first aid across Kano.',
    details: 'Explicitly Hausa-language and faith-aware. IKIRU co-creates short scripts and radio messages that state clearly that epilepsy is a medical condition, not a curse or possession, while speaking respectfully to community values.',
    components: [
      { icon: 'ri-user-settings-line', label: 'Champion Training', desc: 'Two-day practical training on epilepsy facts, seizure first aid, stigma reduction, and referral' },
      { icon: 'ri-building-line', label: 'Faith Leader Engagement', desc: 'Orientation sessions for imams, women\'s religious groups, and community gatekeepers' },
      { icon: 'ri-radio-line', label: 'Hausa Radio Programs', desc: 'Call-in radio content with clinicians and caregivers — high-trust medium in the North' },
      { icon: 'ri-school-line', label: 'School Outreach', desc: 'Sessions for teachers and senior pupils on seizure response and inclusion' },
    ],
    location: 'Kano',
  },
  {
    id: 2,
    number: '02',
    title: 'Seizure First Aid in Schools & Markets',
    tag: 'Public Safety',
    tagIcon: 'ri-first-aid-kit-line',
    icon: 'ri-heart-pulse-line',
    color: '#9333EA',
    image: 'https://readdy.ai/api/search-image?query=First%20aid%20training%20session%20in%20a%20busy%20Nigerian%20market%2C%20health%20worker%20demonstrating%20seizure%20response%20to%20market%20traders%20and%20shoppers%2C%20colorful%20market%20stalls%20in%20background%2C%20engaged%20audience%2C%20practical%20hands-on%20learning%2C%20vibrant%20African%20market%20atmosphere&width=800&height=500&seq=prog102&orientation=landscape',
    summary: 'A highly visible, low-cost campaign converting awareness into practical skills — training schools, markets, transport hubs, and workplaces in seizure first aid and safe response.',
    details: 'Begins in Kano municipal schools and major markets, then adapted for Abuja schools and large employers. Delivered through short in-person demonstrations supported by posters, wallet cards, and WhatsApp-ready visual content.',
    components: [
      { icon: 'ri-school-line', label: 'School Campaigns', desc: 'In-person seizure response demonstrations for teachers and students' },
      { icon: 'ri-store-2-line', label: 'Market Activations', desc: 'Practical training at major markets and transport hubs in Kano and Abuja' },
      { icon: 'ri-smartphone-line', label: 'WhatsApp Content', desc: 'Shareable visual guides and wallet cards for ongoing community reference' },
      { icon: 'ri-building-4-line', label: 'Workplace Programs', desc: 'Employer-facing training for large organisations and government offices' },
    ],
    location: 'Kano & Abuja',
  },
  {
    id: 3,
    number: '03',
    title: 'Family Support Circles & Patient Navigation',
    tag: 'Support',
    tagIcon: 'ri-hand-heart-line',
    icon: 'ri-team-line',
    color: '#7B2D8B',
    image: 'https://readdy.ai/api/search-image?query=Supportive%20group%20therapy%20circle%20for%20epilepsy%20families%20in%20a%20Nigerian%20community%20center%2C%20diverse%20group%20of%20caregivers%20and%20patients%20seated%20in%20circle%2C%20compassionate%20facilitator%2C%20warm%20indoor%20lighting%2C%20emotional%20healing%20and%20community%20support%20atmosphere%2C%20authentic%20African%20setting&width=800&height=500&seq=prog103&orientation=landscape',
    summary: 'Structured support circles combining psychosocial support with practical navigation of care — helping families solve real problems from first seizure to medication adherence, school disclosure, and discrimination.',
    details: 'Each circle includes people living with epilepsy, caregivers, and a trained facilitator linked to a hospital or clinic. In Abuja, circles also become a source of patient stories and advocates for national campaigns.',
    components: [
      { icon: 'ri-map-pin-line', label: 'Kano Circles', desc: 'Hospital-linked and community-linked circles with Hausa facilitation' },
      { icon: 'ri-government-line', label: 'Abuja Circles', desc: 'Mixed circles including professionals, caregivers, and policy advocates' },
      { icon: 'ri-route-line', label: 'Care Navigation', desc: 'Practical guidance on where to go, how to adhere to medication, and managing school disclosure' },
      { icon: 'ri-shield-user-line', label: 'Anti-Discrimination Support', desc: 'Resources and advocacy for families facing stigma and exclusion' },
    ],
    location: 'Kano & Abuja',
  },
  {
    id: 4,
    number: '04',
    title: 'Task-Shifted Epilepsy Access Pilot',
    tag: 'Healthcare',
    tagIcon: 'ri-stethoscope-line',
    icon: 'ri-hospital-line',
    color: '#6D28D9',
    image: 'https://readdy.ai/api/search-image?query=Nigerian%20community%20health%20extension%20worker%20conducting%20epilepsy%20patient%20consultation%20in%20a%20rural%20primary%20care%20facility%2C%20professional%20medical%20setting%2C%20patient%20and%20healthcare%20worker%20interaction%2C%20clean%20clinic%20environment%2C%20Northern%20Nigeria%2C%20compassionate%20and%20professional%20atmosphere&width=800&height=500&seq=prog104&orientation=landscape',
    summary: 'A system-level pilot supporting primary care facilities through community health extension workers — IKIRU as convener, trainer support partner, case follow-up coordinator, and community mobiliser.',
    details: 'Developed in collaboration with AKTH, BUK, and state-level health actors. IKIRU strengthens the system rather than duplicating it — making Kano a proof point for scalable epilepsy service delivery in Northern Nigeria.',
    components: [
      { icon: 'ri-nurse-line', label: 'CHEW Training', desc: 'Community health extension workers trained as frontline epilepsy responders' },
      { icon: 'ri-links-line', label: 'Referral Tools', desc: 'Simple referral systems and patient education materials for primary care' },
      { icon: 'ri-building-2-line', label: 'AKTH Partnership', desc: 'Collaboration with Aminu Kano Teaching Hospital and Bayero University Kano' },
      { icon: 'ri-refresh-line', label: 'Follow-Up Systems', desc: 'Case follow-up coordination to reduce drop-off after initial diagnosis' },
    ],
    location: 'Kano',
  },
  {
    id: 5,
    number: '05',
    title: 'Abuja Policy & Media Lab for Epilepsy Inclusion',
    tag: 'Advocacy',
    tagIcon: 'ri-government-line',
    icon: 'ri-megaphone-line',
    color: '#7B2D8B',
    image: 'https://readdy.ai/api/search-image?query=High-level%20policy%20advocacy%20conference%20in%20Abuja%20Nigeria%2C%20diverse%20group%20of%20government%20officials%2C%20healthcare%20professionals%2C%20and%20civil%20society%20leaders%20in%20a%20modern%20conference%20room%2C%20professional%20setting%2C%20collaborative%20discussion%2C%20Nigerian%20flag%20visible%2C%20formal%20and%20impactful%20atmosphere&width=800&height=500&seq=prog105&orientation=landscape',
    summary: 'Abuja\'s national-facing platform — convening journalists, policymakers, clinicians, civil society, and caregivers around insurance inclusion, school safety protocols, and anti-stigma messaging.',
    details: 'Especially timely given visible federal momentum around neurological care, workforce development, tele-neurology, and stigma reduction. IKIRU shapes the public narrative and positions epilepsy as both a health and social inclusion issue.',
    components: [
      { icon: 'ri-newspaper-line', label: 'Media Engagement', desc: 'Journalist training and media partnerships for accurate epilepsy coverage' },
      { icon: 'ri-file-text-line', label: 'Policy Whitepapers', desc: 'Evidence-based publications on insurance benefits and school safety protocols' },
      { icon: 'ri-group-2-line', label: 'National Coalition', desc: 'Convening NGOs, government, and healthcare institutions around shared goals' },
      { icon: 'ri-broadcast-line', label: 'Public Narrative', desc: 'Campaigns linking real evidence and stories from Kano to national audiences' },
    ],
    location: 'Abuja',
  },
  {
    id: 6,
    number: '06',
    title: 'Northern Nigeria Epilepsy Data & Mapping Desk',
    tag: 'Research',
    tagIcon: 'ri-bar-chart-line',
    icon: 'ri-database-2-line',
    color: '#9333EA',
    image: 'https://readdy.ai/api/search-image?query=African%20data%20analysts%20and%20researchers%20working%20on%20health%20mapping%20project%20in%20a%20modern%20Nigerian%20office%2C%20computers%20showing%20maps%20and%20charts%2C%20collaborative%20team%20environment%2C%20professional%20setting%2C%20focused%20and%20determined%20atmosphere%2C%20clean%20modern%20workspace&width=800&height=500&seq=prog106&orientation=landscape',
    summary: 'A lightweight data and mapping desk collecting structured non-clinical data from outreach events, support groups, referrals, and partner networks — answering questions donors and government partners care about.',
    details: 'Starting in Kano and Abuja allows IKIRU to compare a northern implementation base with a federal policy hub. Over time, this matures into the national epilepsy report envisioned in IKIRU\'s pitch deck.',
    components: [
      { icon: 'ri-survey-line', label: 'Awareness Session Data', desc: 'Attendance, audience type, pre/post knowledge tracking to show stigma reduction progress' },
      { icon: 'ri-team-line', label: 'Support Group Insights', desc: 'Common family barriers, medication access issues, school and work challenges' },
      { icon: 'ri-route-line', label: 'Referral Tracking', desc: 'Source of referral, facility reached, follow-up status to identify system bottlenecks' },
      { icon: 'ri-radio-2-line', label: 'Media Monitoring', desc: 'Radio reach, campaign recall, and story pickups to strengthen advocacy and fundraising' },
    ],
    location: 'Kano & Abuja',
  },
];

export default function ProgramCards() {
  const [expanded, setExpanded] = useState<number | null>(null);

  return (
    <section className="py-24 bg-[#FAF7FC]" id="programs">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-4">
          <span className="text-xs font-semibold uppercase tracking-[4px] text-[#7B2D8B]">Our Programs</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 text-center mb-4">
          Six Programs, <span className="text-[#7B2D8B]">One Mission</span>
        </h2>
        <p className="text-gray-500 text-center max-w-xl mx-auto mb-16 leading-relaxed">
          Each program is designed to work together — building community trust, service access, data, and institutional partnerships across Northern Nigeria.
        </p>

        <div className="space-y-6">
          {programs.map((prog) => (
            <div
              key={prog.id}
              className="bg-white rounded-2xl border border-purple-100 overflow-hidden transition-all duration-300"
            >
              {/* Header row */}
              <button
                className="w-full text-left cursor-pointer"
                onClick={() => setExpanded(expanded === prog.id ? null : prog.id)}
              >
                <div className="flex flex-col md:flex-row items-start md:items-center gap-4 p-6 md:p-8">
                  <span className="text-4xl font-black text-[#7B2D8B]/10 leading-none w-14 shrink-0">{prog.number}</span>
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl shrink-0" style={{ backgroundColor: `${prog.color}15` }}>
                    <i className={`${prog.icon} text-xl`} style={{ color: prog.color }}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <h3 className="font-bold text-gray-900 text-lg">{prog.title}</h3>
                      <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-[#7B2D8B]/10 text-[#7B2D8B] text-xs font-semibold">
                        <i className={`${prog.tagIcon} text-xs`}></i>
                        {prog.tag}
                      </span>
                    </div>
                    <p className="text-gray-500 text-sm leading-relaxed line-clamp-2">{prog.summary}</p>
                  </div>
                  <div className="flex items-center gap-3 shrink-0">
                    <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#FAF7FC] border border-purple-100">
                      <i className="ri-map-pin-line text-[#7B2D8B] text-xs"></i>
                      <span className="text-gray-600 text-xs font-medium whitespace-nowrap">{prog.location}</span>
                    </div>
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#7B2D8B]/10">
                      <i className={`${expanded === prog.id ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-[#7B2D8B] text-lg`}></i>
                    </div>
                  </div>
                </div>
              </button>

              {/* Expanded content */}
              {expanded === prog.id && (
                <div className="border-t border-purple-100">
                  <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
                    <div className="lg:col-span-2 h-56 lg:h-auto">
                      <img
                        src={prog.image}
                        alt={prog.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="lg:col-span-3 p-8">
                      <p className="text-gray-600 text-sm leading-relaxed mb-8">{prog.details}</p>
                      <p className="text-xs font-semibold uppercase tracking-widest text-[#7B2D8B] mb-4">Program Components</p>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {prog.components.map((comp) => (
                          <div key={comp.label} className="flex gap-3">
                            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#7B2D8B]/10 shrink-0 mt-0.5">
                              <i className={`${comp.icon} text-[#7B2D8B] text-sm`}></i>
                            </div>
                            <div>
                              <p className="text-gray-900 text-sm font-semibold mb-0.5">{comp.label}</p>
                              <p className="text-gray-500 text-xs leading-relaxed">{comp.desc}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
